import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink-900 py-14" data-id="element-65" data-mp="3gfsmscqd8umz">
      <div className="mx-auto w-full max-w-page px-5 text-center sm:px-8" data-id="element-66" data-mp="3ggtx2ezk5d3n">
        <p className="display text-2xl text-bone" data-id="element-67" data-mp="32ovwisjwwpj3">✂ Nuevo Nivel™</p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-ash" data-id="element-68" data-mp="36p6df098t0cq">
          Porque un buen blanco no debería cobrarse igual que uno cualquiera.
        </p>

        <ul className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-ash sm:flex-row sm:gap-8" data-id="element-69" data-mp="3ucxpc2qvfbdh">
          <li data-id="element-70" data-mp="36d08okdmdj3">
            <a href="mailto:soportenuevonivel@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-bone" data-id="element-71" data-mp="3lelzi2xtwhm3">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="3qf9sgu5mb8iy" />
              soportenuevonivel@gmail.com
            </a>
          </li>
          <li data-id="element-73" data-mp="2eyjs3rnvlax9">
            <a href="https://www.nuevonivel.shop" className="inline-flex items-center gap-2 transition-colors hover:text-bone" data-id="element-74" data-mp="2ezbf4e3eq0bx">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="3gapf5opniuim" />
              www.nuevonivel.shop
            </a>
          </li>
        </ul>

        <p className="mt-10 border-t border-ink-700 pt-6 text-xs text-ash/70" data-id="element-76" data-mp="3v9b1tiy2kafh">
          © Nuevo Nivel™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}